import React from 'react';

import { Tabs as AntTabs } from 'antd';
import cx from 'classnames';

import styles from './Tabs.module.scss';

/**
 * @typedef { Object } CoreTab
 * @property { string | number } key
 * @property { React.ReactNode } label
 */

/**
 * @typedef { Object }  NormalTab
 * @property { React.ReactNode } [children] - content to render for normal tabs
 */

/**
 * @typedef { Object } CoreTabsProps
 * @property { React.ReactNode } [extraRightContent] content to place on extreme right of tabs
 * @property { 'vertical' | 'horizontal' } [direction] direction of tabs
 * @property { import('antd').TabsProps['onChange'] } [onTabChange]
 *
 */

/**
 * @typedef { Object } TabsProps
 * @property { ( CoreTab & NormalTab)[] } tabs
 * @property { string } [activeKey]
 * @property { string } [className]
 */

/**
 * @description UI component for tabs
 *
 * @author  Rohit Niraj Singh <@rohit.singh3>
 *
 * @reference https://ant.design/components/tabs
 *
 * @param { CoreTabsProps & TabsProps } props
 *
 * @returns {React.Component}
 */
const Tabs = ({
	tabs = [],
	extraRightContent,
	direction = 'horizontal',
	onTabChange,
	activeKey,
	className,
}) => {
	return (
		<AntTabs
			className={cx(styles.tabsWrapper, className)}
			tabPosition={direction === 'horizontal' ? 'top' : 'left'}
			type="line"
			tabBarExtraContent={{
				right: extraRightContent,
			}}
			onChange={onTabChange}
			items={tabs}
			activeKey={activeKey}
		/>
	);
};

Tabs.displayName = 'Tabs';

export default Tabs;
